import { slashTrim } from '../../../lib/linkHandler.ts';

/**
 * This functionality add dynamic css styles to remove icon from external links
 * for PRIMARY POP-UPS in Canvas.
 * PRIMARY POP-UPS data listed in window.externalLinkConfig.popups as array.
 * We have field 'whitelist' for 'Whitelisted Sites' field in modal editor in Canvas.
 * For thees 'whitelist' links we remove external icon in code.
 */

function excludeWhitelist() {
  /**
   * Old structure of primary popup whitelist configuration
   * taken from window.externalLinkConfig array
   */
  const popupsConfigStructureArray = window.externalLinkConfig?.popups || [];
  /**
   * Another structure of primary popup whitelist configuration
   * taken from window.externalLink.primaryPopup
   */
  const primaryPopupWhitelist = window.externalLink?.primaryPopup || '';

  const exceptLinksPatternsDefault = [
    '{{link}}',
    'www.{{link}}',
    '{{link}}/',
    'www.{{link}}/',
    'http://{{link}}',
    'https://{{link}}',
    'http://www.{{link}}',
    'https://www.{{link}}',
    'http://{{link}}/',
    'https://{{link}}/',
    'http://www.{{link}}/',
    'https://www.{{link}}/',
  ];

  const exceptLinksPatternsEnds = ['{{link}}'];

  const exceptList = popupsConfigStructureArray?.length
    ? popupsConfigStructureArray.reduce(
        (prev, { type, whitelist }) =>
          type === 'primary' && whitelist ? [...prev, ...whitelist.split('\n')] : prev,
        [],
      )
    : primaryPopupWhitelist?.whitelist?.split('\n') || [];

  // clearing duplicates from the array.
  const filteredExceptList = exceptList.filter((item, index) => exceptList.indexOf(item) === index);

  // Render string of css rules for list of links
  function renderModalCssList(patternsList, linkItem, hrefAdditional = '') {
    const linkItemNormalized = linkItem
      .replace(/\*/g, '')
      .replace(/^https?:\/\//, '')
      .replace(/www./g, '')
      .replace(/\//gi, '/');

    return patternsList
      .map(exceptItem => {
        return `a[href${hrefAdditional}='${exceptItem.replace(
          /{{link}}/g,
          slashTrim(linkItemNormalized),
        )}']:not(.exclude-external-link-icon):not(.exclude-block-external-link-icon a)::after`;
      })
      .join(', ');
  }

  //List of css exceptions from modal oblect
  const cssModalList = filteredExceptList
    .map(linkItem => {
      const exceptPattern = linkItem.startsWith('*')
        ? exceptLinksPatternsEnds
        : exceptLinksPatternsDefault;
      const hrefAdditional = linkItem.startsWith('*') ? '*' : '^';

      return renderModalCssList(exceptPattern, linkItem, hrefAdditional);
    })
    .join(', ');

  // CSS Modal List Normalized
  const cssModalListNormalized = cssModalList.length ? `, ${cssModalList}` : '';

  //Scc selector with location.origin exception
  const cssSelector = `a[href^='${window.location.origin}']:not(.exclude-external-link-icon):not(.exclude-block-external-link-icon a)::after${cssModalListNormalized}`;

  const style = document.createElement('style');

  style.textContent = `
    ${cssSelector} {
      display: none;
    };
  `;

  document.head.appendChild(style);
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(excludeWhitelist, 0);
});
